import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
//import Services from './components/services/Services'
import Portfolio from './components/portfoli/Portfoli'
//import Testimonials from './components/testimonials/Testimonials'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'

// Since this is a one page so we have to import every component inside return in a series like that on our portfolio
//i.e. header -> Nav -> About -> Experience etc and the empty tags are fragments
const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  )
}

export default App